import type { FaireProductEntity } from "../../entity_types/product";

export const p_ygenhkyj6p: FaireProductEntity = {
  token: "p_ygenhkyj6p",
  type: "product",
  name: "Lemon Lavender Hot Stuff Heated Neck Wrap",
  brandToken: "b_5o8ey581fk",
  brandName: "DM Merchandising",
  imageUrl: "https://cdn.faire.com/fastly/6369844eb7cd02fca4dfe6c192678a65f85faf97ab3373cd1bf03af6953d96ca.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bad970c3be208b803215c1f097c65b2aa5b71bbfa6f11bde5edc89708c63964d.jpeg",
    "https://cdn.faire.com/fastly/e68671f0727f6f015319bae25649f7a39e252a93de31ac437398bc40458b4284.jpeg",
    "https://cdn.faire.com/fastly/d3813b67c398e25d639fd638b9ffd10e7590a2d6927e528dee323c65790e11d6.jpeg",
    "https://cdn.faire.com/fastly/2f2d14dd513e80aee4d1e8f3d0497e0a98a586363230d4e17cfd52de83ca1dfb.jpeg",
    "https://cdn.faire.com/fastly/4a6e60ce52213ddf0157b41086cf7ec57bfd6e5f711b9287730d7a5d22583319.jpeg",
    "https://cdn.faire.com/fastly/ecb9885a994eb8d63a84524063b024968b5864a4f7939b646f62f0ea13c7c216.jpeg",
    "https://cdn.faire.com/fastly/e4538b07a7326f7d809b25ba2b45cc3d0e8da4c72b228709b8d458a9298ba5e7.jpeg",
    "https://cdn.faire.com/fastly/34f2d11fb7ff6757e82db9581350d6d55abd88417e626c87bf4643e8ce12b126.jpeg",
    "https://cdn.faire.com/fastly/d8d995a5ecd17fed8124b50a5442e1538804b98cab80ddba33248748e80708d8.jpeg",
    "https://cdn.faire.com/fastly/154b619075178617d6e758651bafdab8fb6787821f8f080341cda7c644380378.jpeg"
  ],
  priceDollars: 7.5,
  description: "Lemon Lavender® Hot Stuff Heated Neck Wrap\nGet that warm, fuzzy feeling with a neck wrap that hugs all the right spots. Filled with temp-smart spa seeds, this weighted microfiber wrap radiates warmth. Two handy handles keep your wrap in place to ease tension and de-stress from the day. \n\n-Microwave for gentle heat therapy\n-Filled with temp-smart spa seeds\n-Velvety microfiber\n-Handy double handles to keep in place\n-6 fun styles\n-12 piece assortment\n-Ships in a free counter display\n-Boxed and peggable",
  tags: [],
  msrpDollars: 18.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:23.794Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
